"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsInfoItem = exports.itemTypes = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const product_details_info_styles_1 = require("./product-details-info.styles");
exports.itemTypes = {
    TEXT: 'text',
    DATE: 'date',
};
const ProductDetailsInfoItem = ({ label, value, type, render, }) => {
    const { formatDate } = (0, ui_components_1.useLocalization)();
    const renderValue = () => {
        if (render) {
            return render();
        }
        if (type === exports.itemTypes.TEXT) {
            return value;
        }
        if (type === exports.itemTypes.DATE) {
            return formatDate(value);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, !!(label && renderValue())
        && (react_1.default.createElement(product_details_info_styles_1.StyledDetailsInfoItem, null, react_1.default.createElement(product_details_info_styles_1.StyledDetailsInfoItemLabel, null, label), react_1.default.createElement(product_details_info_styles_1.StyledDetailsInfoItemValue, null, renderValue())))));
};
exports.ProductDetailsInfoItem = ProductDetailsInfoItem;
